module.exports = __webpack_public_path__ + "img/other_frame.165160d2.jpg";